import { Modal } from '@mantine/core';

import { saveAs } from 'file-saver';

import { ReactComponent as NoPreviewIcon } from 'assets/icons/noPreviewIcon.svg';
import PrimaryButton from 'components/primaryButton';

const NoPreview = ({ noPreviewModal, setNoPreviewModal, file, name }) => {
  return (
    <div>
      <Modal
        opened={noPreviewModal}
        onClose={() => {
          setNoPreviewModal(false);
        }}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size={'70%'}
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full font-bold  text-lg py-4  text-center text-primary',
          modal: 'pl-10 ',
          body: 'scroller -mr-4 pr-8 ',
        }}
      >
        <div className='flex justify-center flex-col items-center mb-5 min-h-[50]'>
          <NoPreviewIcon />

          <h1 className='text-primary text-xl my-8'>
            Preview not available. Please download the file.
          </h1>

          <button
            onClick={() => {
              saveAs(file, name);
              setNoPreviewModal(false);
            }}
          >
            <PrimaryButton>Download</PrimaryButton>
          </button>
        </div>
        {/* <div className='flex justify-center items-center mt-2'>
          <button
            onClick={() => setPreviewImageModal(false)}
            className='cursor-pointer'
          >
            <SecondaryButton>Cancel</SecondaryButton>
          </button>
        </div> */}
      </Modal>
    </div>
  );
};

export default NoPreview;
